import React from 'react'
import { Box } from '@hanzo/ui'

import Image from 'next/image'

import { YouTubeEmbed as YouTubeLazyLoad } from '@hanzo/ui/primitives'

const Title: React.FC = () => (
  <Box className='relative not-typography h-[30px] w-full overflow-hidden'>
  <Image 
    src='/assets/content/press-lilamax-white.png'
    alt=''
    width={70}
    height={24}
    className='absolute top-px-2 left-px-0'
  />
  <Box tag='span' className='text-[15px] font-normal absolute top-[5px] left-[73px]'>from</Box>
  <Image 
    src='/assets/content/press-nasdaq-white.png'
    alt=''
    width={90}
    height={26}
    className='absolute top-[3px] left-[109px]'
  />
  </Box>
)
const Entire: React.FC = () => {
  return<>
    <Title />
    <YouTubeLazyLoad 
      youtubeID='TEz6Xq9A5Mk' 
      timeAt='5s'
      width={500}
      height={281}
      buttonSize={70} 
      caption='Lux - Transforming the future of Financial Tech thr...'
    />
  </>
}


export default Entire
